<section *ngIf="isMobile" id="mobHeader" class="mobileSingleHeader">
	<img
		class="user-avatar dropdown-toggle"
		src="{{ userData && userData.imageUrl }}"
	/>
	<span class="pageTitle">{{ 'USERMENU.MEMBERSHIP' | translate }}</span>
	<fa-icon icon="times" class="times" routerLink="calendar"></fa-icon>
</section>

<div
	*ngIf="isLoading"
	class="redirect-waiting flex align-center justify-center"
>
	<freud-loader size="lg" [bgColor]="false"></freud-loader>
</div>

<!-- #region DESKTOP && TABLET -->
<div
	*ngIf="!isMobile && !isLoading && !hasSubscription()"
	class="deskContent"
	(window:resize)="onResize()"
>
	<div class="flex">
		<div class="column">
			<div class="column-header">
				<h1 innerHTML="{{ 'PAGES.MEMBERSHIP.TITLE' | translate }}"></h1>
				<h2 innerHTML="{{ 'PAGES.MEMBERSHIP.SUBTITLE' | translate }}"></h2>
			</div>

			<div class="list">
				<div *ngFor="let benefit of benefits" class="list-item">
					{{ 'PAGES.MEMBERSHIP.BENEFITS.DESKTOP.'.concat(benefit) | translate }}
				</div>
			</div>

			<div class="captions">
				<div
					*ngFor="let caption of captions"
					class="caption-item"
					[innerHTML]="'PAGES.MEMBERSHIP.CAPTIONS.'.concat(caption) | translate"
				></div>
			</div>
		</div>

		<div class="column flex">
			<ng-container *ngFor="let subscription of subscriptions; let i = index">
				<div class="column flex flex-wrap">
					<div class="box" [ngClass]="getSubscriptionClass(subscription.name)">
						<div class="border"></div>

						<div class="column-header">
							<span
								*ngIf="subscription.recommended || subscription.current"
								class="flag"
							>
								{{
									(subscription.recommended
										? 'PAGES.MEMBERSHIP.BEST_OPTION'
										: subscription.current
										? 'PAGES.MEMBERSHIP.CURRENT_PLAN'
										: ''
									) | translate
								}}
							</span>
							<h3
								innerHTML="{{
									'PAGES.MEMBERSHIP.PLANS.'.concat(subscription.name)
										| translate
								}}"
							></h3>
							<h4
								innerHTML="{{
									'PAGES.MEMBERSHIP.PLANS.'.concat(
										subscription.name,
										'_DESCRIPTION'
									) | translate
								}}"
							></h4>
						</div>

						<div class="list">
							<div
								*ngFor="let value of subscription.benefits"
								class="list-item"
							>
								<img
									*ngIf="value === true"
									src="assets/images/icons/approve.svg"
									alt="Yes"
									class="list-item-icon"
								/>
								<span
									*ngIf="typeOf(value) != 'boolean'"
									innerHTML="{{
										'PAGES.MEMBERSHIP.BENEFITS_VALUES.'.concat(value)
											| translate
									}}"
								></span>
							</div>
						</div>
					</div>

					<div *ngIf="!i" class="plan">
						<div
							*ngFor="let item of plans; let ind = index"
							(click)="item.active && checkPlanOption(ind)"
							[class.content-flag]="item.flag"
							[class.disabled]="!item.active"
							[class.selected]="item.selected"
							class="box flex align-center"
						>
							<span *ngIf="item.flag" class="flag">{{
								'PAGES.MEMBERSHIP.SAVE_PERCENTAGE'
									| translate: { value: item.flag }
							}}</span>

							<div class="plan-left flex">
								<img
									[src]="
										'assets/images/icons/' +
										(item.selected ? 'approve.svg' : 'radio-unchecked.svg')
									"
									class="list-item-icon"
								/>
								<span class="plan-name" [innerHTML]="item.name"></span>
							</div>

							<div class="plan-right">
								<ng-container [ngSwitch]="item?.period.period">
									<div *ngSwitchCase="'month'" class="plan-monthly">
										<span
											class="plan-monthly-value"
											[innerHTML]="
												currencyService.getCurrencySymbol(item.currency) +
												item.monthlyPrice
											"
										></span>
										{{ 'PAGES.MEMBERSHIP.PER_MONTH' | translate }}
									</div>

									<div *ngSwitchCase="'year'" class="plan-year">
										<span
											class="plan-year-value"
											[innerHTML]="
												currencyService.getCurrencySymbol(item.currency) +
												item.monthlyPrice
											"
										></span>
										{{ 'PAGES.MEMBERSHIP.PER_YEAR' | translate }}
									</div>
								</ng-container>
							</div>
						</div>

						<button
							*ngIf="plans?.length && !buttonLoading"
							(click)="signPlan()"
							class="button-submit"
							type="button"
						>
							{{ 'PAGES.MEMBERSHIP.BUTTON_SUBSCRIBE_PLAN' | translate }}
						</button>

						<div
							*ngIf="buttonLoading"
							class="loading flex align-center justify-center"
						>
							<freud-loader size="lg" [bgColor]="false"></freud-loader>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
<!-- #endregion -->

<!-- #region MOBILE -->
<div
	*ngIf="isMobile && !isLoading && !hasSubscription()"
	class="mobContent"
	(window:resize)="onResize()"
>
	<h1 innerHTML="{{ 'PAGES.MEMBERSHIP.TITLE' | translate }}"></h1>

	<div class="plan">
		<div
			*ngFor="let item of plans; let ind = index"
			(click)="item.active && checkPlanOption(ind)"
			[class.content-flag]="item.flag"
			[class.disabled]="!item.active"
			[class.selected]="item.selected"
			class="box flex align-center"
		>
			<span *ngIf="item.flag" class="flag">{{
				'PAGES.MEMBERSHIP.SAVE_PERCENTAGE' | translate: { value: item.flag }
			}}</span>

			<div class="plan-left flex">
				<img
					[src]="
						'assets/images/icons/' +
						(item.selected ? 'approve.svg' : 'radio-unchecked.svg')
					"
					class="list-item-icon"
				/>
				<span class="plan-name" [innerHTML]="item.name"></span>
			</div>

			<div class="plan-right">
				<ng-container [ngSwitch]="item?.period.period">
					<div *ngSwitchCase="'month'" class="plan-monthly">
						<span
							class="plan-monthly-value"
							[innerHTML]="
								currencyService.getCurrencySymbol(item.currency) +
								item.monthlyPrice
							"
						></span>
						{{ 'PAGES.MEMBERSHIP.PER_MONTH' | translate }}
					</div>

					<div *ngSwitchCase="'year'" class="plan-monthly">
						<span
							class="plan-monthly-value"
							[innerHTML]="
								currencyService.getCurrencySymbol(item.currency) +
								item.monthlyPrice
							"
						></span>
						{{ 'PAGES.MEMBERSHIP.PER_YEAR' | translate }}
					</div>
				</ng-container>
			</div>
		</div>
	</div>

	<h2 innerHTML="{{ 'PAGES.MEMBERSHIP.SUBTITLE_MOBILE' | translate }}"></h2>

	<div class="list">
		<div *ngFor="let benefit of benefits" class="list-item">
			<img src="assets/images/icons/approve.svg" class="list-item-icon" />
			<div>
				{{ 'PAGES.MEMBERSHIP.BENEFITS.MOBILE.'.concat(benefit) | translate }}
			</div>
		</div>
	</div>

	<div class="captions">
		<div
			*ngFor="let caption of captions"
			class="caption-item"
			[innerHTML]="'PAGES.MEMBERSHIP.CAPTIONS.'.concat(caption) | translate"
		></div>
	</div>

	<div class="action-bar">
		<button
			*ngIf="plans?.length && !buttonLoading"
			(click)="signPlan()"
			class="button-submit"
			type="button"
		>
			{{ 'PAGES.MEMBERSHIP.BUTTON_SUBSCRIBE_PLAN' | translate }}
		</button>

		<div *ngIf="buttonLoading" class="loading flex align-center justify-center">
			<freud-loader size="lg" [bgColor]="false"></freud-loader>
		</div>
	</div>
</div>
<!-- #endregion -->

<!-- #region YOUR SUBSCRIPTION -->
<div
	*ngIf="!isLoading && hasSubscription()"
	class="yourSubscription"
	(window:resize)="onResize()"
>
	<h1 innerHTML="{{ 'PAGES.YOUR_SUBSCRIPTION.TITLE' | translate }}"></h1>

	<table>
		<tr *ngFor="let item of yourSubscription">
			<th *ngIf="getYourSubscriptionData(item)">
				{{ 'PAGES.YOUR_SUBSCRIPTION.TABLE.'.concat(item) | translate }}
			</th>
			<td *ngIf="getYourSubscriptionData(item)">
				{{ getYourSubscriptionData(item) }}
			</td>
		</tr>
		<tr *ngIf="subscriptionStatusIs(enableUpdatePaymentMethod)">
			<td colspan="2" style="border: 0px">
				<freud-button
					class="btnStripeCustomerPortal"
					(click)="goToStripeCustomerPortal()"
				>
					<span
						class="
							freud-icon freud-icon-md freud-icon-credit-card
							credit-card-icon
						"
					></span>
					<p class="text-stripe-customer-portal">
						{{
							'PAGES.YOUR_SUBSCRIPTION.BUTTON_UPDATE_PAYMENT_METHOD' | translate
						}}
					</p>
				</freud-button>
			</td>
		</tr>
	</table>

	<div
		class="cancelation-message zk-rounded-md zk-p-4 zk-mt-6"
		*ngIf="
			subscriptionStatusIs(enableUndoCancelationStates) && !isButtonLoading
		"
	>
		{{
			'PAGES.YOUR_SUBSCRIPTION.CANCELLED_MESSAGE'
				| translate
					: {
							date: getSubscription().currentPeriodEndsAt | date: 'dd/MM/yy'
					  }
		}}
	</div>

	<button
		id="cancelation-button"
		(click)="showCancelModal()"
		class="button-submit button-submit-cancel zk-text-base zk-font-thick"
		type="button"
		*ngIf="
			subscriptionStatusIs(enableCancelationStates) &&
			userData?.tags?.length > 0 &&
			!hasPVProfessionalTag
		"
	>
		{{ 'PAGES.YOUR_SUBSCRIPTION.BUTTON_CANCEL_PLAN' | translate }}
	</button>

	<button
		(click)="cancelSubscription()"
		class="button-submit button-submit-change-plan"
		type="button"
		*ngIf="subscriptionStatusIs(enableChangePlanStates)"
	>
		{{ 'PAGES.YOUR_SUBSCRIPTION.BUTTON_CHANGE_PLAN' | translate }}
	</button>

	<button
		(click)="goToCheckout()"
		class="button-submit"
		type="button"
		*ngIf="subscriptionStatusIs(enableRepayStates)"
	>
		{{ 'PAGES.YOUR_SUBSCRIPTION.BUTTON_PAY_AGAIN' | translate }}
	</button>

	<button
		(click)="undoCancelation()"
		class="button-submit button-submit-undo-cancel zk-font-thick"
		type="button"
		*ngIf="
			subscriptionStatusIs(enableUndoCancelationStates) && !isButtonLoading
		"
	>
		{{ 'PAGES.YOUR_SUBSCRIPTION.BUTTON_UNDO_CANCELATION' | translate }}
	</button>

	<div *ngIf="isButtonLoading" class="loading flex align-center justify-center">
		<freud-loader size="sm" [bgColor]="false"></freud-loader>
	</div>
</div>

<office-modal id="modalCancelation" [isOpen]="modalCancellation.isOpen">
	<office-modal-container [class.step2]="modalCancellation.currentStep === 2">
		<div header class="office-modal-header">
			<h1 *ngIf="modalCancellation.currentStep === 3">
				{{
					'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_3.HEADER' | translate
				}}
			</h1>
			<h1 *ngIf="modalCancellation.currentStep != 3">
				{{ 'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.HEADER' | translate }}
			</h1>
			<button
				class="modal-close"
				(click)="trackRequestCancel(); modalCancellation.isOpen = false"
			>
				<office-icon name="close"></office-icon>
			</button>
		</div>

		<div body class="office-modal-body">
			<h1 class="zk-leading-8">
				{{
					'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_'.concat(
						modalCancellation.currentStep.toString(),
						'.TITLE'
					) | translate
				}}
			</h1>
			<p *ngIf="modalCancellation.currentStep === 1">
				{{
					'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_1.TEXT' | translate
				}}
			</p>
			<p
				class="step2"
				*ngIf="
					modalCancellation.currentStep === 2 &&
					getSubscription().currentPeriodEndsAt
				"
			>
				{{
					'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_2.TEXT'
						| translate
							: {
									date: getSubscription().currentPeriodEndsAt | date: 'dd/MM/yy'
							  }
				}}
			</p>
			<div *ngIf="modalCancellation.currentStep === 1">
				<div
					class="item zk-text-left zk-cursor-pointer zk-mt-2 zk-mb-2 zk-flex"
					*ngFor="
						let reasonItem of modalCancellation.details.STEP_1.ITEMS;
						let index = index
					"
				>
					<input
						type="radio"
						class="zk-w-5 zk-h-5"
						[value]="index"
						[checked]="index === modalCancellation.reasonIndex"
						[(ngModel)]="modalCancellation.reasonIndex"
					/>
					<span
						class="zk-font-thick zk-ml-4 zk-mt-1"
						(click)="modalCancellation.reasonIndex = index"
						>{{ reasonItem }}</span
					>
				</div>
				<div
					class="item zk-text-left zk-cursor-pointer zk-mt-2 zk-mb-2 zk-flex"
				>
					<input
						type="radio"
						class="zk-w-5 zk-h-5"
						[value]="modalCancellation.details.STEP_1.ITEMS.length"
						[checked]="
							modalCancellation.details.STEP_1.ITEMS.length ===
							modalCancellation.reasonIndex
						"
						[(ngModel)]="modalCancellation.reasonIndex"
					/>
					<div class="zk-mt-1 zk-ml-2 zk-w-full">
						<span
							class="zk-font-thick zk-ml-2"
							(click)="
								modalCancellation.reasonIndex =
									modalCancellation.details.STEP_1.ITEMS.length
							"
						>
							{{
								'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_1.OTHERS'
									| translate
							}}
						</span>
						<br />
						<div
							class="zk-mt-2 zk-w-full"
							*ngIf="
								modalCancellation.details.STEP_1.ITEMS.length ===
								modalCancellation.reasonIndex
							"
						>
							<zk-input
								class="zk-mb-3 sm:zk-mt-4 zk-w-full"
								[zkStatus]="isReasonInvalid() ? 'error' : 'default'"
							>
								<input
									id="reason"
									zkInputRef
									[formControl]="cancellationDescription"
									placeholder="{{
										'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_1.OTHERS_DESCRIPTION'
											| translate
									}}"
								/>
								<span zkInputLabel>{{
									'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_1.OTHERS_DESCRIPTION'
										| translate
								}}</span>

								<div
									zkInputMessage
									class="text-danger"
									[class.zk-hidden]="!isReasonInvalid()"
								>
									{{ getReasonErrorMessage() }}
								</div>
							</zk-input>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="modalCancellation.currentStep === 2">
				<p class="zk-text-left subtitle zk-font-thick">
					{{
						'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_2.SUBTITLE'
							| translate
					}}
				</p>
				<ul class="zk-text-base zk-ml-6 zk-text-left zk-leading-5 zk-list-disc">
					<li
						class="zk-mb-2"
						*ngFor="let item of ['ITEM_1', 'ITEM_2', 'ITEM_3', 'ITEM_4']"
					>
						{{
							'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_2.'.concat(item)
								| translate
						}}
					</li>
				</ul>

				<div class="zk-text-base zk-text-left zk-mt-6 footer-message">
					{{
						'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.STEP_2.FOOTER_MESSAGE'
							| translate
					}}
				</div>
			</div>
		</div>

		<div
			footer
			class="office-modal-footer justify-center"
			[ngClass]="{
				'zk-flex': modalCancellation.currentStep != 2,
				'zk-block md:zk-flex': modalCancellation.currentStep === 2
			}"
		>
			<ng-container *ngIf="!modalCancellation.isLoading">
				<ng-container *ngIf="modalCancellation.currentStep === 1">
					<button
						zk-button
						zkButtonColor="white"
						id="cancellation-step-1-cancel"
						class="zk-mr-4 small-rounded without-shadow"
						zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
						(click)="trackRequestCancel(); modalCancellation.isOpen = false"
					>
						{{
							'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.ACTIONS.CANCEL'
								| translate
						}}
					</button>
					<button
						zk-button
						zkButtonColor="primary"
						id="cancellation-step-1-confirm"
						class="small-rounded"
						[disabled]="isModalStep1Disabled()"
						zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
						(click)="trackContinue(); onContinueCancellationDialog()"
					>
						{{
							'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.ACTIONS.CONTINUE'
								| translate
						}}
					</button>
				</ng-container>

				<ng-container *ngIf="modalCancellation.currentStep === 2">
					<button
						zk-button
						zkButtonColor="white"
						id="cancellation-step-2-confirm"
						class="zk-mr-4 small-rounded without-shadow"
						[disabled]="isModalStep1Disabled()"
						zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
						(click)="onContinueCancellationDialog()"
					>
						{{
							'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.ACTIONS.CONFIRMATION_CANCELLATION'
								| translate
						}}
					</button>
					<button
						zk-button
						zkButtonColor="primary"
						id="cancellation-step-2-cancel"
						class="small-rounded"
						zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
						(click)="trackRequestCancel(); setCancelationModal(false)"
					>
						{{
							'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.ACTIONS.CONFIRMATION_CANCEL'
								| translate
						}}
					</button>
				</ng-container>

				<ng-container *ngIf="modalCancellation.currentStep === 3">
					<button
						zk-button
						zkButtonColor="primary"
						id="cancellation-step-3-confirm"
						class="small-rounded"
						zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
						(click)="onContinueCancellationDialog()"
					>
						{{
							'PAGES.YOUR_SUBSCRIPTION.MODALS.CANCELATION.ACTIONS.OK'
								| translate
						}}
					</button>
				</ng-container>
			</ng-container>

			<div
				*ngIf="modalCancellation.isLoading"
				class="loading flex align-center justify-center"
			>
				<freud-loader size="sm" [bgColor]="false"></freud-loader>
			</div>
		</div>
	</office-modal-container>
</office-modal>

<!-- #endregion -->

<!-- Modal Financial profile required -->
<zk-dialog
	class="financial-required-dialog"
	[(isOpen)]="isModalFinancialOpened"
>
	<ng-container zk-dialog-header>
		{{
			'PAGES.YOUR_SUBSCRIPTION.MODALS.FINANCIAL_PROFILE_REQUIRED.HEADER'
				| translate
		}}
	</ng-container>
	<ng-container zk-dialog-body>
		<h2 class="zk-font-thick zk-whitespace-pre-line zk-mb-4 zk-text-1">
			{{
				'PAGES.YOUR_SUBSCRIPTION.MODALS.FINANCIAL_PROFILE_REQUIRED.TITLE'
					| translate
			}}
		</h2>

		<p class="zk-text-sm zk-text-left zk-text-2">
			{{
				'PAGES.YOUR_SUBSCRIPTION.MODALS.FINANCIAL_PROFILE_REQUIRED.MESSAGE'
					| translate
			}}
		</p>
	</ng-container>
	<ng-container zk-dialog-footer>
		<div class="zk-flex zk-items-center zk-justify-center zk-w-64 zk-px-4">
			<button
				zk-button
				zkButtonColor="primary"
				type="button"
				zkButtonSize="medium"
				(click)="goToPaymentAccount()"
			>
				{{
					'PAGES.YOUR_SUBSCRIPTION.MODALS.FINANCIAL_PROFILE_REQUIRED.BUTTON'
						| translate
				}}
			</button>
		</div>
	</ng-container>
</zk-dialog>
<!-- End Modal Financial profile required -->
